import { APIHelper } from "../utilities";
import { rootUrl } from "./urls";

export function getAllDesigners() {
    return APIHelper.baseRequest(APIHelper.GET, `${rootUrl}/Designers`, { contentType: APIHelper.getMultipartReqHeader(), headers: APIHelper.getGenericHeaders() });
}